import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { env } from "../env";
import { getLocalStorage } from "../utils/function/localStorage";

export const earningApi = createApi({
  reducerPath: "earningApi",
  baseQuery: fetchBaseQuery({
    baseUrl: env.BASE_URL,
    // mode: 'cors',
    prepareHeaders: (headers) => {
      headers.set("authorization", getLocalStorage("safe_secure_token"));
      return headers;
    },
  }),
  tagTypes: ["adminEarning", "user", "boosterController"], // automatic-data fetching
  endpoints: (builder) => ({
    // user earning
    roiIncomeDataUser: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/get_investment`,
      providesTags: ["user"], // automatic-data fetching
    }),
    levelIncomeDataUser: builder.query({
      // query: (user_id) => `/secure/api/user/level_income/${user_id}`,
      query: () => `/secure/level_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
    rewardIncomeDataUser: builder.query({
      // query: (user_id) => `/secure/api/user/reward_income/${user_id}`,
      query: () => `/secure/api/reward_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
    // graphchart data
    getRoiIncomeDataUserChart: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/roi_income_chart`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getLevelIncomeDataUserChart: builder.query({
      // query: (user_id) => `/secure/api/user/level_income/${user_id}`,
      query: () => `/secure/level_income_chart`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getRewardIncomeDataUserChart: builder.query({
      // query: (user_id) => `/secure/api/user/reward_income/${user_id}`,
      query: () => `/secure/reward_income_chart`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getRoyaltyIncomeHistory: builder.query({
      query: () => "/api/v1/secure/getroyaltyincomehistory",
      providesTags: ["user"], // automatic-data fetching
    }),
    getAutoPoolHistoryEarning: builder.query({
      query: () => "/api/v1/secure/getautopool_history",
      providesTags: ["user"], // automatic-data fetching
    }),
    getDirectLevelIncome: builder.query({
      query: () => "/api/v1/secure/direct_level_income",
      providesTags: ["user"], // automatic-data fetching
    }),
    getInDirectLevelIncome: builder.query({
      query: () => "/api/v1/secure/indirec_tlevel_income",
      providesTags: ["user"], // automatic-data fetching
    }),
    getGiftIncomeHistory: builder.query({
      query: () => "/api/v1/secure/gift_income_history",
      providesTags: ["user"], // automatic-data fetching
    }),
    getDirectWithdrawIncome: builder.query({
      query: () => "/api/v1/secure/direct_withdraw_income",
      providesTags: ["user"], // automatic-data fetching
    }),
    getIncomeLevelUpdate: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/api/income_level_update`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getBoosterIncomeHistory: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/api/booster_history`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getUserActivationIncome: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/api/user_activation_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getDirectFundTransferIncome: builder.query({
      // query: (user_id) => `/secure/api/user/get_investment/${user_id}`,
      query: () => `/secure/api/direct_fundtransfer_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getBonanzaAchievement: builder.query({
      query: () => `/secure/api/getBonanzaAchievement`,
    }),
    getBonanzaPrize: builder.query({
      query: () => `/secure/api/getBonanzaPrize`,
    }),
    getBoosterUpgradeUserIncome: builder.query({
      query: () => `/secure/api/sponsor_booster_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
    /////////////////////////////////// User/////////////////////
    getAllLevelIncomeHistoryUser: builder.query({
      // SAST API
      // SAST API
      query: (query) =>
        `/api/v1/secure/get_level_income?page=${query?.page}&limit=${query?.limit}&searchById=${query?.searchById}&startDate=${query?.startDate}&endDate=${query?.endDate}&csv=${query?.csv}`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getUserRankIncome: builder.query({
      // SAST API
      // SAST API
      query: (query) =>
        `/api/v1/secure/get_rank_income?page=${query.page}&limit=${query.limit}`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getUserBonusIncome: builder.query({
      // SAST API
      // SAST API
      query: (query) =>
        `/api/v1/secure/get_bonus_income?page=${query.page}&limit=${query.limit}`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getRoiIncomeHistoryUser: builder.query({
      // SAST API
      query: (query) =>
        `/api/v1/secure/get_roi_income?page=${query?.page}&limit=${query?.limit}`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getRewardHistoryUser: builder.query({
      // SAST API
      query: () => `/api/v1/secure/get_reward`,
      providesTags: ["user"], // automatic-data fetching
    }),
    getDailyIncomeUser: builder.query({
      // SAST API
      query: () => `/api/v1/secure/get_daily_income`,
      providesTags: ["user"], // automatic-data fetching
    }),
  }),
});

export const {
  useRoiIncomeDataQuery,
  useLevelIncomeDataQuery,
  useRoiIncomeDataUserQuery,
  useGetIncomeLevelUpdateQuery,
  useGetDirectWithdrawIncomeQuery,
  useLevelIncomeDataUserQuery,
  useRewardIncomeDataUserQuery,
  useGetLevelIncomeDataUserChartQuery,
  useGetRewardIncomeDataUserChartQuery,
  useGetRoiIncomeDataUserChartQuery,
  useGetRoyaltyMembersAdminQuery,
  useGetRoyaltyIncomeHistoryAdminQuery,
  useGetAutopoolMembersAdminQuery,
  useAddTreeAutoPoolAdminMutation,
  useGetBoosterIncomeMembersAdminQuery,
  useGetAllBoosterIncomeIDsAdminQuery,
  useGetBoosterUpgradeIncomeQuery,
  useGetBoosterUpgradeUserIncomeQuery,
  useAddBoostTreeAutPoolAdminMutation,
  useGetRoyaltyIncomeHistoryQuery,
  useGetAutoPoolHistoryEarningQuery,
  useAddSendRoyaltyMembersMoneyAdminMutation,
  useGetDirectLevelIncomeQuery,
  useGetInDirectLevelIncomeQuery,
  useGetGiftIncomeHistoryQuery,
  useGetGiftIncomeHistoryAdminQuery,
  useGetGiftTransferUserListAdminQuery,
  useGetIncomeLevelUpdateAdminQuery,
  useGetGiftTransferHistoryAdminQuery,
  useGetUserTopupHistoryAdminQuery,
  useAddSendGiftAllUserAdminMutation,
  useAddSendGiftSingleUserAdminMutation,
  useGetBoosterIncomeHistoryQuery,
  useGetIndirectIncomeHistoryAdminQuery,
  useGetDirectIncomeHistoryAdminQuery,
  useGetDirectFundTransferIncomeQuery,
  useGetUserActivationIncomeQuery,
  useGetDirectWithdrawIncomeHistoryAdminQuery,
  useGetBonanzaAchievementQuery,
  useGetBonanzaPrizeQuery,
  useGetSingleBonanzaAchieveMutation,
  useGetAllBonanzaAchieverListQuery,
  useGetAllBonanzaPrizeQuery,
  useGetBoosterControllUsersQuery,
  useUpdateBoosterControllerMutation,
  // **************** SST PRO NEW ENDPOINT **********************
  useGetAllDirLevIncomeHistoryAdminQuery, // SAST API
  useGetAllRankIncomeHistoryAdminQuery,
  useGetAllRankBonusIncomeHistoryAdminQuery,
  useGetAllStakingIncomeHistoryAdminQuery, // SAST API
  useGetAllStakingLevelIncomeHistoryAdminQuery,
  useGetAllBonusRewardIncomeHistoryAdminQuery,
  useGetAllGlobalPoolIncomeHistoryAdminQuery,
  useAddGlobalPoolIncomeAdminMutation,
  useGetGlobalPoolUserListAdminQuery,
  ////////////////// User //////////////
  useGetAllLevelIncomeHistoryUserQuery, // SAST API
  useGetRoiIncomeHistoryUserQuery, // SAST API
  useGetRewardHistoryUserQuery, // SAST API
  useGetUserRankIncomeQuery, // SAST API
  useGetUserBonusIncomeQuery, // SAST API
  useGetDailyIncomeUserQuery,
} = earningApi;
